import { Channel } from '../../realtime/types';
import { Entity } from '../types';

export const inboxUnreadCountEntityId = 'inboxUnreadCount';
export const notificationsUnreadCountEntityId = 'notificationsUnreadCount';
export const networkEventsStatusesEntityId = 'networkEventsStatusesEntityId';
export const userEventsStatusesEntityId = 'userEventsStatusesEntityId';
export const userActionsEntityId = 'userActions';

export enum RealtimeSubscriptionType {
  Feed = 'Feed',
  GroupEventsStatuses = 'GroupEventsStatuses',
  GroupUnreadCount = 'GroupUnreadCount',
  InboxUnreadCount = 'InboxUnreadCount',
  MessageReactions = 'MessageReactions',
  NestedReplies = 'NestedReplies',
  NetworkEventsStatuses = 'NetworkEventsStatuses',
  NotificationsUnreadCount = 'NotificationsUnreadCount',
  PausedFeed = 'PausedFeed',
  PausedFeedTelemetry = 'PausedFeedTelemetry',
  PushNotification = 'PushNotification',
  RepliesOnStaticallySortedFeed = 'RepliesOnStaticallySortedFeed',
  RepliesOnStaticallySortedFeedTelemetry = 'RepliesOnStaticallySortedFeedTelemetry',
  RestrictedPostingUpdates = 'RestrictedPostingUpdates',
  TeamsMeetingSettings = 'TeamsMeetingSettings',
  TeamsMeetingRole = 'TeamsMeetingRole',
  Thread = 'Thread',
  TypingIndicator = 'TypingIndicator',
  UserActions = 'UserActions',
  UserEventsStatuses = 'UserEventsStatuses',
  ModeratorFeedRemoveThreads = 'ModeratorFeedRemoveThreads',
}

export interface SubscriptionItem {
  readonly channel: Channel;
  readonly count: number;
}

export type SubscriptionsMap = Record<Entity['id'], SubscriptionItem>;
export type RealtimeSubscriptions = Record<RealtimeSubscriptionType, SubscriptionsMap>;
